export default "__VITE_ASSET__D_l3ccuw__"